<template>
  <v-card color="grey lighten-2" class="mb-12" :max-height="`${maxHeight}px`" style="overflow-y: auto">
    <div class="pa-2">
      <v-data-table
        v-model="_value"
        :headers="headers"
        :items="basesLiberadas"
        :single-select="false"
        show-select
        dense
        hide-default-footer
        disable-sort
        :items-per-page="-1"
        class="elevation-1 table-bases-dados-perfis"
      >
        <template v-slot:[`item.status`]="{ item }">
          <status-bases :status="item.status" />
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>
<script>
  export default {
    components: {
      StatusBases: () => import('@/components/perfis/StatusBases.vue')
    },

    props: {
      /* bases seleconadas v-model */
      value: {
        type: Array,
        required: true
      },

      maxHeight: {
        type: Number,
        required: true
      },
      basesLiberadas: {
        type: Array,
        required: true
      }
    },

    emits: ['input'],

    data: () => ({
      headers: [
        { text: 'Bases', value: 'descricao', align: 'start' },
        { text: 'Status', value: 'status' }
      ]
    }),

    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue);
        }
      }
    }
  };
</script>
<style>
  .table-bases-dados-perfis table thead th {
    font-weight: 400 !important;
  }
</style>